var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageReceivedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Recived",
    transform: "translate(-52.201 -151.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    "data-name": "Group 1382",
    transform: "translate(61.402 151.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M114.7,0,129.63,11.1,144.558,0Z",
    transform: "translate(-114.702 -0.001)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    "data-name": "Group 1379",
    transform: "translate(52.701 153.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629",
    transform: "translate(7.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M113.475,35.422a1.182,1.182,0,0,1-1.41,0L96.4,23.774V35.58a14.937,14.937,0,0,1,19.685,11.466h11.873a1.182,1.182,0,0,0,1.182-1.182V23.774Z",
    transform: "translate(-96.4 -23.774)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_12",
    "data-name": 12,
    transform: "translate(0 12.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M144,267.43A12.57,12.57,0,1,0,156.57,280h0A12.57,12.57,0,0,0,144,267.43Z",
    transform: "translate(-131.43 -267.43)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M148.63,280.84l-3.8,3.8a1.18,1.18,0,0,1-1.67,0l-3.8-3.8a1.2,1.2,0,0,1,0-1.68,1.18,1.18,0,0,1,1.67,0h0l1.78,1.78V276.2a1.181,1.181,0,0,1,2.36,0v4.74l1.78-1.78a1.2,1.2,0,0,1,1.68,0,1.18,1.18,0,0,1,0,1.67h0Z",
    transform: "translate(-131.43 -267.43)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageReceivedIcon);
export default __webpack_public_path__ + "static/media/message-received-icon.de0a6338b22db9b754c076962f0d6906.svg";
export { ForwardRef as ReactComponent };